import { RPDF } from '../common/react-pdf';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';
import { ChartInfo } from '../common/types';
import { describeArc } from '../info/calculations/chart-calculations';

const radius = 48;
const x0 = 60;
const y0 = 60;
const arcWidth = 11;
let startAngle = 0;

interface Props {
  data: ChartInfo[];
}

export const VisitsChart: React.FC<Props> = (props) => {
  const i18next = useScopedTranslation('calendar.report');
  const visitsCount = props.data.reduce((s, v) => (s = s + v.count), 0);

  return (
    <RPDF.Svg height={120} width={120} viewBox="0 0 120 120">
      {props.data.length > 1 ? (
        props.data
          .sort(function (a, b) {
            return a.visitType.order - b.visitType.order;
          })
          .map((visitType) => {
            const a1 = startAngle;
            const da = (visitType.count * 360) / visitsCount;
            const a2 = a1 + da;
            startAngle = a2;
            return (
              <RPDF.Path
                key={visitType.visitType.name}
                d={describeArc(x0, y0, radius, arcWidth, a1, a2)}
                fill={visitType.visitType.color}
                stroke={visitType.visitType.color}
              />
            );
          })
      ) : (
        <RPDF.Circle
          cx={x0}
          cy={y0}
          r={radius + arcWidth}
          stroke={'#ffffff'}
          stroke-width="1"
          fill={props.data[0]?.visitType.color ?? '#D3DCEA'}
        />
      )}
      <RPDF.Circle
        cx={x0}
        cy={y0}
        r={radius}
        stroke={'#ffffff'}
        stroke-width="1"
        fill={'#ffffff'}
      />
      <RPDF.Circle
        cx={x0}
        cy={y0}
        r={radius + arcWidth + 0.5}
        stroke={'#ffffff'}
        stroke-width="1"
      />
      <RPDF.Text
        style={RPDF.chartStyles.charCountText}
        x="50%"
        y="45%"
        dominantBaseline="middle"
        textAnchor="middle"
        fill="#1E265D"
      >
        {visitsCount}
      </RPDF.Text>
      <RPDF.Text
        style={RPDF.chartStyles.charTypeText}
        x="50%"
        y="58%"
        dominantBaseline="middle"
        textAnchor="middle"
        fill="#1E265D"
      >
        {i18next.t('chart_visits')}
      </RPDF.Text>
    </RPDF.Svg>
  );
};
